var app = angular.module('leonardo');

var CurrencyConfig = function($provide) {
  $provide.decorator('$locale', ['$delegate', function($delegate) {
      if($delegate.id == 'en-us') {
        $delegate.NUMBER_FORMATS.PATTERNS[1].negPre = '-\u00A4';
        $delegate.NUMBER_FORMATS.PATTERNS[1].negSuf = '';
      }
      return $delegate;
    }]);
};

app.config(['$provide', CurrencyConfig]);
